import React, {useCallback, useMemo} from 'react';
import {Product} from 'components/customer/Product/entity/Product';
import {
    CommentBox,
    Title,
    TextContainer,
} from 'components/customer/JobDashboard/columns/SharedComponents';
import styled from 'styled-components';
import Icon from 'shared/Icon';

export const ApplianceVariation = ({product}: {product: Product}) => {
    const rangeHoodVariation = useMemo(() => {
        let make = '';
        let model = '';
        let spec = '';
        let hasCustomRangehood = false;

        if (product && product.appliance && product.appliance.custom) {
            hasCustomRangehood = true;
            make = product.appliance.make;
            model = product.appliance.model;

            if (typeof product.appliance.specPath == 'string') {
                if (product.appliance.specPath.indexOf('/') > 0) {
                    spec = `/${product.appliance.specPath}`;
                } else {
                    spec = product.appliance.specPath;
                }
            }
        }

        return {
            hasCustomRangehood,
            make,
            model,
            spec,
        };
    }, [product]);

    const noPropagate = useCallback((event: React.MouseEvent) => {
        event.stopPropagation();
    }, []);

    if (rangeHoodVariation.hasCustomRangehood) {
        return (
            <CommentBox $showAll={false} $type="primary">
                <Title>
                    Rangehood Variation
                    {rangeHoodVariation.spec ? (
                        <SpecLink
                            onClick={noPropagate}
                            href={rangeHoodVariation.spec}
                            target="_blank"
                            title="Download specification"
                            rel="noreferrer">
                            <SpecIcon
                                iconName="Button-Create-PDF.svg"
                                showAltText={false}
                            />
                        </SpecLink>
                    ) : null}
                </Title>
                <LocalTextContainer $showAll={false}>
                    <div>
                        {rangeHoodVariation.make} {rangeHoodVariation.model}
                    </div>
                </LocalTextContainer>
            </CommentBox>
        );
    }
};

const SpecLink = styled.a`
    display: inline-flex;
    line-height: 0;
    margin-left: 5px;
`;

const SpecIcon = styled(Icon)`
    width: 20px !important;
`;

const LocalTextContainer = styled(TextContainer)`
    height: auto;
    display: block;
    overflow: visible;

    > div {
        position: static;
        height: auto;
        width: 100%;
        overflow: visible;
        border: 0;
        padding: 0;
        background: transparent;
    }
`;
